import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IOption, MultiSelect, Tooltip } from "@digital-services/ui";

import ErrorComponent from "@components/ErrorComponent";
import LoadingComponent from "@components/LoadingComponent";

import { ApplicationJsonItemResponse } from "@applications/models/ApplicationJsonModel";
import { useGetAssociatedApplications } from "@applications/services/ApplicationService";

const ApplicationsMultiselect: FunctionComponent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "organization.applications"
  });
  const [options, setOptions] = useState<IOption[]>([]);
  const [appsWithErrors, setAppsWithErrors] = useState<
    ApplicationJsonItemResponse[]
  >([]);

  const { applications, isLoading, error } = useGetAssociatedApplications();

  useEffect(() => {
    if (applications) {
      const options: IOption[] = [];
      const temp: ApplicationJsonItemResponse[] = [];

      applications.forEach((appResponse: ApplicationJsonItemResponse) => {
        const application = appResponse.data;
        options.push({ label: application.name, value: application.id });

        if (appResponse.error) {
          temp.push(appResponse);
        }
      });

      setOptions(options);
      setAppsWithErrors(temp);
    }
  }, [applications]);

  if (isLoading) return <LoadingComponent message={t("load.message")} />;

  if (error) return <ErrorComponent message={t("load.error.message")} />;

  if (!applications)
    return <ErrorComponent message={t("load.error.message")} />;

  const hasAppErrors = appsWithErrors.length > 0;
  const tooltipMessage = hasAppErrors
    ? appsWithErrors.map(item => (
        <p key={item?.data?.id}>
          {item?.data?.name} : {item.error}
        </p>
      ))
    : null;

  return (
    <div data-testid="associated-applications">
      <Tooltip message={tooltipMessage} placement="bottom-left">
        <MultiSelect
          error={hasAppErrors}
          label={t("label")}
          placeholder={
            applications?.length === 0 ? t("load.none.message") : undefined
          }
          disabled={true}
          options={options}
          selected={applications?.length === 0 ? null : options}
          onChange={() => undefined}
        />
      </Tooltip>
    </div>
  );
};

export default ApplicationsMultiselect;
